/* SpawnAnything — the setup panel as a hub: big tiles that open the menu windows (Armeen, Bauen, Items, Welt), each
   with a one-line summary of what is set. Replaces the nested blocks of the old panel step by step; the windows keep
   the original controls (and ids), so main.js, the campaign and multiplayer keep working. */
import './setupHub.css';

export function createSetupHub() {
  const panel = document.getElementById('panel');
  const hub = document.createElement('div'); hub.className = 'hub';
  const presets = document.getElementById('presets')?.closest('#panel > div');
  if (presets) presets.after(hub); else panel?.prepend(hub);
  const tiles = [];
  function refresh() { for (const t of tiles) t.sum.textContent = t.summary ? t.summary() : ''; }
  // summaries follow the controls; cheap enough to poll while the panel is visible
  setInterval(() => { if (panel && !panel.hidden) refresh(); }, 700);
  return {
    el: hub,
    /** { key, icon (tabler class), title, open(), summary() } in display order */
    add({ key, icon, title, open, summary }) {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'hub-tile'; if (key) b.dataset.hub = key;
      b.innerHTML = `<i class="ti ${icon}" aria-hidden="true"></i><span class="hub-t">${title}</span><span class="hub-s"></span>`;
      b.addEventListener('click', () => open());
      hub.appendChild(b);
      const t = { b, sum: b.querySelector('.hub-s'), summary };
      tiles.push(t); refresh();
      return b;
    },
    refresh,
  };
}
